<template>
  <div class="bannerCTA">
    <img class=" lazyload bannerCTA__logo" src="../assets/img/src/awards/award2022.svg" alt="Awards 2022 Icon">
    <div class="wrapper">
      <p class="h3 bannerCTA__awardText">
        Voted best villa rental company in the world seven years in a row
      </p>
      <p class="h1 bannerCTA__inspireText uppercase">
        The thinking traveller exists <span class="lowercase">to</span> inspire memories through places <span class="lowercase">with</span> soul.
      </p>
      <app-link id="47" type="page" class="btn-underlined-light-lrg">
        About us
      </app-link>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/_config.scss";

.bannerCTA {
    background-image:url("https://www.thethinkingtraveller.com/media/Homepage/About_us/about_us_back.jpg") ;
    background-size: cover;
    background-position: center;
    height: 720px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    position: relative;
  &__logo {
      width: 120px;
      height: 120px;
      position: absolute;
      right: 40px;
      top: 40px;
      @media (max-width: 800px)  {
        position: static;
        margin: 0 auto;

      }
  }

  &__awardText{
      color: $white;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.7;
      max-width: 400px;
      margin: 0 auto;
      @media (max-width: 480px)  {
        font-size: 12px;
      }
  }

  &__inspireText{
      color:$lunarioAcid;
      @media screen and (max-width: 800px)  {
        font-size: 40px;
      }
      @media screen and (max-width: 480px)  {
        font-size: 32px;
      }
  }

}

</style>
